import { useEffect } from 'react';
import ls from 'local-storage';

export const useUrlAuthParams = (isServer) => {
  useEffect(() => {
    if (!isServer) {
      const searchParams = new URLSearchParams(window.location.search);
      const token = searchParams.get('token');
      const eroGuestId = searchParams.get('ero_guest_id');

      if (token) {
        ls.set('token', token);
      }

      if (eroGuestId) {
        ls.set('ero_guest_id', eroGuestId);
      }

      if (token || eroGuestId) {
        searchParams.delete('token');
        searchParams.delete('ero_guest_id');

        const newUrl = window.location.pathname + (searchParams.toString() ? `?${searchParams.toString()}` : '') + window.location.hash;

        window.history.replaceState({}, '', newUrl);

        if (token && eroGuestId) {
          window.location.reload();
        }
      }
    }
  }, []);
}; 